import { Dispatch, useCallback } from 'react';

import { IProperty } from 'src/interfaces/Property';
import { useNotifications } from 'src/providers/notificationsProvider/NotificationsConsumer';
import { changePropertySourceMode } from 'src/services/PropertiesService';
import { URL_SET_SOURCES } from 'src/types/UrlSetSources';

import {
	applySourceConversion,
	PropertySettingsAction,
	setLoading,
	setSourceMode as setSourceModeAction
} from '../state';

interface UsePropertySourceModeParams {
	dispatch: Dispatch<PropertySettingsAction>;
}

export type SetSourceModeFn = (draft: IProperty, nextSourceMode: URL_SET_SOURCES) => Promise<void>;

export function usePropertySourceMode({ dispatch }: UsePropertySourceModeParams): SetSourceModeFn {
	const notificationsContext = useNotifications();

	return useCallback(
		async (draft: IProperty, nextSourceMode: URL_SET_SOURCES): Promise<void> => {
			if (draft.urlSetConfiguration?.source === nextSourceMode) {
				dispatch(setSourceModeAction(nextSourceMode));
				return;
			}
			dispatch(setLoading(true));
			try {
				const converted = await changePropertySourceMode(draft, nextSourceMode);
				dispatch(applySourceConversion(converted));
			} catch (err) {
				dispatch(setLoading(false));
				notificationsContext.alert({
					errorMessage: 'Error while trying to change mode.',
					serverError: err
				});
			}
		},
		[dispatch, notificationsContext]
	);
}
